import '@modifi/client-polyfills'
import React from 'react'
import {createRoot} from 'react-dom/client'

import getApp from './App'

const config = {
  useSuspense: true,
  plugins: {
    i18n: {
      react: {
        useSuspense: true,
      },
    },
  },
}

getApp(config).then(App => {
  const container = document.getElementById('root') as HTMLElement
  const root = createRoot(container)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
})
